import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MapGoogleService } from 'src/app/services/map-google.service';
import { SignalingImageSituationEnum, SignalingTypeEnum, SystemModuleEnum } from 'src/enumerators';
import { environment } from 'src/environments/environment';
import { DeviceSignaling, HorizontalSignaling, VerticalSignaling } from 'src/models';

@Component({
  selector: 'app-signaling-info',
  templateUrl: './signaling-info.component.html',
  styleUrls: ['./signaling-info.component.css', '../info-window-dinamic.component.css']
})
export class SignalingInfoComponent implements OnInit {

  @Input() signaling: any;

  principalImage = "assets/img/image-popover-default.png";
  uri = environment.uri();
  signCode;
  url
  occurrenceHref = '';

  index = 0;

  constructor(
    public _mapGoogleService: MapGoogleService,
  ) { }

  ngOnInit() {
    if (this.signaling?.verticalSignalingFiles?.length) {
      let signsImages = this.signaling.verticalSignalingFiles.filter(f => f.situation == SignalingImageSituationEnum.Before)
      if (signsImages.length) this.principalImage = signsImages[0]?.url;
      else this.principalImage = this.signaling.verticalSignalingFiles[0].url

    } else if (this.signaling?.horizontalSignalingFiles?.length) {
      let signsImages = this.signaling.horizontalSignalingFiles.filter(f => f.situation == SignalingImageSituationEnum.Before)
      if (signsImages.length) this.principalImage = signsImages[0]?.url;
      else this.principalImage = this.signaling.horizontalSignalingFiles[0].url

    } else if (this.signaling?.deviceSignalingFiles?.length) {
      let signsImages = this.signaling.deviceSignalingFiles.filter(f => f.situation == SignalingImageSituationEnum.Before)
      if (signsImages.length) this.principalImage = signsImages[0]?.url;
      else this.principalImage = this.signaling.deviceSignalingFiles[0].url

    }

    if (this.signaling.type == SignalingTypeEnum.Vertical) this.signCode = this.signaling.trafficSigns[0].signCode;
    else this.signCode = this.signaling.signCode;

    this.url =
      this.signaling.type == SignalingTypeEnum.Vertical
        ? `${this.uri}/#/catalog/detail/${this.signaling.id}?type=${this.signaling.trafficSigns[0].id}`
        : `${this.uri}/#/catalog/detail/${this.signaling.id}?type=${this.signaling.type}`;

    this.occurrenceHref = this.signaling?.occurrence?.id && this.signaling?.occurrence?.type
      ? `#/catalog/occurrences/display?id=${this.signaling.occurrence.id}&type=${this.signaling.occurrence.type}`
      : '';
  }

  openDuplicatedSideBar() {
    this._mapGoogleService.sidebarIdSelected = this.signaling.id;
    this._mapGoogleService.sidebarSelected = this.signaling;
    this._mapGoogleService.sidebarMapOpen = true;
    this._mapGoogleService.sidebarType = SystemModuleEnum.SignalingRegister;
  }

  openDetails(url) {
    window.open(url, '_blank');
  }

  openModal() {
    console.log('teste');

  }

  onHoverEnter(index: number) {
    this.index = index;
    if (this.signaling.type == SignalingTypeEnum.Vertical) this.signCode = this.signaling.trafficSigns[index].signCode;
    else this.signCode = this.signaling.signCode;
  }
}
